import { pluralize } from '@pepper/utils/src/function/pluralize'
import { unparse } from 'papaparse'

export const kFormat = (num: number) => {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  })
    .format(num)
    .toLowerCase()
}

export const trimCommaSeparatedList = (values: string) => {
  return values
    .split(',')
    .map(value => value.trim())
    .filter(value => value)
    .join(',')
}

export const downloadSample = ({
  sampleRecord,
  sampleFileName,
}: {
  sampleRecord: unknown[]
  sampleFileName: string
}) => {
  const csv = unparse(sampleRecord, {
    header: false,
  })
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', sampleFileName)
  link.click()
}

type GetBulkImportMsgArgs = {
  type: 'Topic' | 'Keyword'
  totalAdded: number
  totalSkipped: number
}

export const getBulkImportMsg = ({
  type,
  totalAdded,
  totalSkipped,
}: GetBulkImportMsgArgs) => {
  if (totalSkipped > 0 && totalAdded > 0) {
    return `${pluralize(totalAdded, type)} added (${pluralize(
      totalSkipped,
      'duplicate'
    )} skipped)`
  } else if (totalAdded === 0) {
    return `Skipped adding ${type}s as all ${type}s already exist`
  } else {
    return `${pluralize(totalAdded, type)} added successfully`
  }
}

export const formatTopicsAndKeywordsCount = (value: string) => {
  const maxCount = 50
  const count = value.split(',').length
  if (count >= maxCount) {
    return `${maxCount}+`
  }
  return count
}
